import { LayoutModule } from '@angular/cdk/layout';
import { HttpClientModule } from '@angular/common/http';
import { APP_ID, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NbLayoutModule } from '@nebular/theme';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { environment } from '../environments/environment';
import { APP_ROUTES } from './app-routes';
import { AppThemeModule } from './app-theme.module';
import { AppComponent } from './app.component';
import {
  APP_CURRENCY_CODE_PROVIDER,
  APP_LOCALE_PROVIDER,
  BACK_API_INTERCEPTOR_PROVIDER,
  ERROR_INTERCEPTOR_PROVIDER,
  TOKEN_INTERCEPTOR_PROVIDER,
} from './app.providers';
import { APP_ID as appIdValue } from './app.tokens';
import { ErrorsModule } from './shared/components/errors/errors.module';
import { metaReducers, reducers } from './store';
import { AuthEffects } from './store/auth/effects';
import { ConversationEffects } from './store/conversation/effects';
import { DeviceEffects } from './store/device/effects';
import { HostChannelEffects } from './store/host-channel/effects';
import { MessageEffects } from './store/message/effects';
import { TrackingEffects } from './store/tracking/effects';
@NgModule({
  imports: [
    HttpClientModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(APP_ROUTES, {
      initialNavigation: 'enabledBlocking',
    }),
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictActionImmutability: true,
        strictActionSerializability: true,
        strictActionTypeUniqueness: true,
        strictActionWithinNgZone: true,
        strictStateImmutability: true,
        strictStateSerializability: true,
      },
    }),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
    EffectsModule.forRoot([
      AuthEffects,
      HostChannelEffects,
      MessageEffects,
      ConversationEffects,
      TrackingEffects,
      DeviceEffects,
    ]),
    AppThemeModule,
    LayoutModule,
    NbLayoutModule,
    ErrorsModule,
  ],
  declarations: [AppComponent],
  providers: [
    APP_LOCALE_PROVIDER,
    APP_CURRENCY_CODE_PROVIDER,
    BACK_API_INTERCEPTOR_PROVIDER,
    TOKEN_INTERCEPTOR_PROVIDER,
    ERROR_INTERCEPTOR_PROVIDER,
    { provide: APP_ID, useValue: appIdValue },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
